import { contextFactory } from '@frontend/design-system';
import { OnboardingModuleTasksConfig } from '../types';

export const [OnboardingModuleTasksContext, useOnboardingModuleTasks] = contextFactory<OnboardingModuleTasksConfig>();
